import React, { createContext, useReducer, useContext } from "react";
import reducer from "./axiosReducer";

const Context = createContext();

const defaultState = {
  cancelToken: null
};

export function useStore() {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useStore must be used within context provider");
  }
  return context;
}

export function useSelector(fn) {
  const { state } = useStore();

  return fn(state);
}

export function useDispatch() {
  const { dispatch } = useStore();
  return dispatch;
}

export function createProvider(initialState = {}) {
  return function Provider({ children }) {
    const [state, dispatch] = useReducer(reducer, defaultState);

    return (
      <Context.Provider value={{ state, dispatch }}>
        {children}
      </Context.Provider>
    );
  };
}
